var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rabbey-table',{ref:"table",attrs:{"headers":_vm.headers,"callback-index":_vm.callbackIndex,"index-url":"/api/serviceRequests/GetSims"},on:{"get:data":_vm.getData}})
}
var staticRenderFns = []

export { render, staticRenderFns }